export interface ISilentError {
  isSilent?: boolean;
}
export class SilentError extends Error implements ISilentError{
  readonly isSilent = true;
  constructor(message?: string) {
    super(message);
  }
}
